export default __webpack_public_path__ + "static/media/refresh.4b5521fc.svg";